import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Modal } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import TableWidget from '../../TableWidget.js';
import { AddEditOvertimeCaps } from './addEditOvertimeSettings.js';
import Button from '~/components/CustomButton/CustomButton';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { shortDateFormat } from '~/utils/dateFormat.js';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

const formatData = function (data, t, dateTimeRules) {
    return data.map(item => ({
        name: item.name,
        isActive: item.is_active ? t('Active') : t('Inactive'),
        validity: (item.valid_from ? `${t("From")} ${shortDateFormat(item.valid_from, dateTimeRules)} ` : "- ") + (item.valid_to ? `- ${t("To")} ${shortDateFormat(item.valid_to, dateTimeRules)}` : ""),
        code: "non_deletable"
    }));
}
class OvertimeCaps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            overtimeCapSettings: [],
            isEdit: false,
            editData: {},
            loading: false
        }
        this.updateData = this.updateData.bind(this);
        this.ruleActivation = this.ruleActivation.bind(this);
    }

    updateData = async (data) => {
        const { commonStore, t, clientStore } = this.props;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        this.setState({ loading: true }, async () => {
            try {
                if (this.state?.editData?.id)
                    await clientStore.updateOvertimeCapSetting(this.state.editData.id, data);
                else
                    await clientStore.saveOvertimeCapSetting(data);
                commonStore.addNotification(t('Overtime setting saved successfully!'), null, 'success');
                this.loadData()
            } catch (err) {
                console.error(err)
                this.setState({ loading: false })
            }
        })
    }

    componentDidMount() {
        this.setState({ loading: true }, this.loadData);
    }

    loadData = async () => {
        const { clientStore } = this.props;
        try {
            const result = await clientStore.getOvertimeCapSettings();
            this.setState({
                overtimeCapSettings: result.overtimeCapSettings,
                isEdit: false,
                loading: false,
            });
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    activateDeactivate = (id, value) => {
        this.setState({ loading: true }, async () => {
            try {
                await this.props.clientStore.activationOvertimeCapSetting(id, { status: value });
                this.loadData();
            } catch (err) {
                console.error(err);
                this.setState({ loading: false });
            }
        });
    }

    ruleActivation = (id, value) => {
        const { t } = this.props
        const message = value === 'active' ? 'Activating this rule will lock it from further changes.' : 'Deactivating this rule will also deactivate all linked overtime cap settings in user profiles';
        confirmAlert({
            title: t('Are You Sure?'),
            message: t(message),
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.activateDeactivate(id, value)
                },
                {
                    label: 'No'
                }
            ]
        });
    }

    editOvertime = (index) => {
        const data = this.state.overtimeCapSettings[index];
        this.toggleModal(true, data);
    }

    toggleModal = (value, data) => {
        this.setState({ isEdit: value, editData: data });
    }

    render() {
        const { t, commonStore } = this.props;
        const { isEdit, loading } = this.state
        if (loading) return <LoadingSpinner />

        const dateTimeRules = commonStore.getDateTimeRules();

        return (
            <>
                <Row>
                    <Col xs={{ span: 4, offset: 8 }} className='d-flex justify-content-end mt-2'>
                        <Button wd fill onClick={() => this.toggleModal(true, {})}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" /> {this.props.t('Add new')}
                        </Button>
                    </Col>
                </Row>
                <TableWidget
                    headers={['Name', 'Status', 'Validity']}
                    metaData={[
                        { field: 'name', type: 'text' },
                        { field: 'isActive', type: 'text' },
                        { field: 'validity', type: 'text' }
                    ]}
                    data={formatData(this.state.overtimeCapSettings, t)}
                    onChange={_ => { }}
                    minRemoveIndex={0}
                    customDeleteHandler={_ => { }}
                    page={'overtimeCapSettings'}
                    customFormHandler={this.editOvertime}
                />
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {})}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Overtime Cap Settings')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {})}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <AddEditOvertimeCaps
                            values={this.state.editData}
                            updateData={this.updateData}
                            ruleActivation={this.ruleActivation}
                            cancel={() => this.toggleModal(false, {})}
                            t={t}
                            dateTimeRules
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(withRemoveDialog(observer(OvertimeCaps))));
